require('./company-advantages.js');
require('./index-offer-slider.js');
require('./producer-slider');
require('./index-actions');
require('./product-slider');
require('./product-page-top.js');
require('./hero-slider');